import { Button } from "@mantine/core";

import { useGetDarkMode } from "_common/hooks/global";
import BackgroundWrapper  from "_components/atoms/backgroundWrapper";
import Icon               from "_components/atoms/icon";
import Image              from "_components/atoms/image";
import Typography         from "_components/atoms/typography";
import useStyles          from "_styles/molecules/QRCode";

const component = props => {
	const {
		handleClose = () => { },
		cancelMouseOut = () => { }
	} = props;

	const { classes } = useStyles ( undefined, { name: "styles" } );
	const darkMode    = useGetDarkMode ();

	return (
		<BackgroundWrapper
			className    = { `${ classes.popOverContainer } ${ props?.containerClass || "" }` }
			onMouseEnter = { cancelMouseOut }
			onMouseLeave = { handleClose }
			type         = "tertiary"

		>
			<div>
				<Typography
					style = { { textAlign: "center", paddingBottom: "2rem" } }
					title = { "Download the App" }
				/>

				<div className = { classes.buttonContainer }>
					<a href = "https://play.google.com/store/apps/details?id=com.threesixteen.app&hl=en_IN&gl=US">
						<Button
							classNames = { { root: classes.buttonStyles } }
							radius     = "xl"
						>

							{darkMode ? (
								<Icon
									className = { classes.iconStyles }
									name      = "playstore_icon_darkmode"
								/>
							)
								: (
									<Icon
										className = { classes.iconStyles }
										name      = "playstore_icon"
									/>
								)}

							<Typography
								className = { `${ classes.btnText } capitalize` }
								size      = "md"
								title     = { "Playstore" }
								weight    = "500"
							/>
						</Button>
					</a>

					<a href = "https://apps.apple.com/in/app/rooter-live-gaming-sports/id1115677906">
						<Button
							classNames = { { root: classes.buttonStyles } }
							radius     = "xl"
						>

							{darkMode ? (
								<Icon
									className = { classes.iconStyles }
									name      = "apple_store_icon_darkmode"
								/>
							)
								: (
									<Icon
										className = { classes.iconStyles }
										name      = "apple_store_icon"
									/>
								)}

							<Typography
								className = { `${ classes.btnText } capitalize` }
								size      = "md"
								title     = { "App Store" }
								weight    = "500"
							/>
						</Button>
					</a>
				</div>
			</div>

			<div className = { classes.QRCodeParent }>

				<Image
					className = { classes.qrImage }
					src       = "/images/qr/QR_Code.webp"
				/>
			</div>

		</BackgroundWrapper>
	);
};

export default component;
